<template>
  <div :style="$cmsStyles('c_4787681a6bbe')" class="brand-cooperation-wrapper">
    <div class="box-header">
      <h2 class="box-header-title">{{ $cms('c_4787681a6bbe', 'f_0001', "自营品牌合作") }}</h2>
      <div class="box-header-en-title">{{ $cms('c_4787681a6bbe', 'f_0002', "Brand Cooperation") }}</div>
      <div class="box-header-desc">{{ $cms('c_4787681a6bbe', 'f_0003', "期待与优秀主播和渠道商合作共赢") }}</div>
    </div>
    <div class="box-content">
      <div class="info">{{ $cms('c_4787681a6bbe', 'f_0004', "客服热线：400-900-1231") }}<br />{{ $cms('c_4787681a6bbe', 'f_0005', "周一至周五 9：00-18：00 （节假日除外）") }}</div>
      <div class="btns">
        <div class="btn-common btn-white" @click="onJoinClick(3)">{{ $cms('c_4787681a6bbe', 'f_0006', "主播合作") }}</div>
        <div class="btn-common" @click="onJoinClick(4)">{{ $cms('c_4787681a6bbe', 'f_0007', "渠道合作") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {

    }
  },
  methods: {
    onJoinClick(type) {
      this.$router.push(`/apply-join?type=${type}`)
    },
  }
}
</script>


<style lang="less" scoped>
  @import '../../style/common.less';

  .brand-cooperation-wrapper {
    .pxToVw(height, 759);
    background-image: var(--cms-c_4787681a6bbe-f_0008, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804173847080000961.17543003268199117.jpg?x-oss-process=image/quality,Q_80"));
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .box-header {
      .pxToVw(padding-top, 80);
      color: #FFF;
      &-title {
        margin: 0 auto 8 * @unitVw;
        .pxToVw(margin-bottom, 28);
        text-align: center;
        .pxToVw(line-height, 50);
        .pxToVw(font-size, 36);
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          .pxToVw(top, 64);
          left: 50%;
          .pxToVw(width, 160);
          height: 1px;
          background: #d8d8d8;
          transform: translateX(-50%);
        }
      }
      &-en-title {
        font-weight: 500;
        .pxToVw(font-size, 18);
        .pxToVw(line-height, 26);
        text-align: center;
        .pxToVw(margin-bottom, 26);
      }
      &-desc {
        text-align: center;
        .pxToVw(line-height, 25);
        .pxToVw(font-size, 18);
        font-weight: 300;
        color: #FFF;
      }
    }
    .box-content {
      .pxToVw(margin-top, 60);
      .pxToVw(height, 1440);
      .pxToVw(height, 400);
      
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #FFF;
      .info {
        .pxToVw(margin-bottom, 60);
        text-align: center;
        .pxToVw(font-size, 24);
        .pxToVw(line-height, 34);
        font-weight: 500;
      }

      .btns {
        display: flex;
        justify-content: center;
      }
    }
  }
</style>

